import { render, staticRenderFns } from "./renewal-order-change-business-user-modal.vue?vue&type=template&id=53ba8ee9"
import script from "./renewal-order-change-business-user-modal.vue?vue&type=script&lang=js"
export * from "./renewal-order-change-business-user-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports